import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { API } from '../api'

export function TermsPage() {
    const navigate = useNavigate()
    const [salvando, setSalvando] = useState(false)
    const [erro, setErro] = useState('')

    // O aceite fica gravado no cadastro do participante (data/hora) antes de seguir
    const handleAccept = async () => {
        setSalvando(true)
        setErro('')
        try {
            await axios.post(`${API.ASSESSMENT}/aceite-termos`, { token: sessionStorage.getItem('token') })
            navigate('/menu')
        } catch (err: any) {
            setErro(err.response?.data?.error || 'Não foi possível registrar o aceite. Tente novamente.')
            setSalvando(false)
        }
    }

    return (
        <div style={{
            backgroundColor: 'white',
            color: '#333',
            minHeight: '100dvh',
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 'clamp(16px, 4vw, 24px)',
            boxSizing: 'border-box'
        }}>
            <div style={{ maxWidth: '600px', width: '100%' }}>
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <div style={{
                        width: '56px',
                        height: '56px',
                        backgroundColor: '#0e1d72',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px'
                    }}>
                        <span style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>BMI</span>
                    </div>
                    <h1 style={{ fontSize: 'clamp(20px, 5vw, 24px)', fontWeight: 'bold', color: '#0e1d72', margin: '0 0 8px' }}>
                        Termos de Participação
                    </h1>
                    <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>
                        Leia com atenção antes de iniciar o assessment
                    </p>
                </div>

                <div style={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    border: '1px solid #ddd',
                    padding: 'clamp(18px, 5vw, 30px)',
                    marginBottom: '20px',
                    boxSizing: 'border-box'
                }}>
                    <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#0e1d72', marginBottom: '12px' }}>
                        Confidencialidade e Uso dos Dados
                    </h2>
                    <p style={{ fontSize: '14px', color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
                        As respostas fornecidas neste instrumento são <strong>individuais e confidenciais</strong>.
                        Os dados serão processados de forma agregada, garantindo o anonimato de cada participante.
                        Nenhuma resposta individual será identificada ou divulgada.
                    </p>

                    <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#0e1d72', marginBottom: '12px' }}>
                        Objetivo do Assessment
                    </h2>
                    <p style={{ fontSize: '14px', color: '#444', lineHeight: '1.7', marginBottom: '16px' }}>
                        Este assessment tem como objetivo mapear a cultura organizacional por meio da
                        avaliação das <strong>Características Culturais (CCs)</strong> e suas respectivas
                        manifestações funcionais (MF) e disfuncionais (MD). Os resultados apoiarão
                        o processo de desenvolvimento organizacional conduzido pelo BMI.
                    </p>

                    <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#0e1d72', marginBottom: '12px' }}>
                        Participação Voluntária
                    </h2>
                    <p style={{ fontSize: '14px', color: '#444', lineHeight: '1.7', margin: 0 }}>
                        Sua participação é voluntária. Ao clicar em <strong>"Aceitar e Continuar"</strong>,
                        você confirma que leu e concorda com os termos acima e que participará
                        do assessment de forma consciente e espontânea.
                    </p>
                </div>

                <button
                    onClick={handleAccept}
                    disabled={salvando}
                    style={{
                        width: '100%',
                        padding: '14px',
                        backgroundColor: salvando ? '#6c757d' : '#0e1d72',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: salvando ? 'not-allowed' : 'pointer',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        minHeight: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxSizing: 'border-box'
                    }}
                >
                    {salvando ? 'Registrando aceite...' : 'Aceitar e Continuar'}
                </button>
                {erro && (
                    <div role="alert" style={{ marginTop: '12px', padding: '12px', backgroundColor: '#fee', border: '1px solid #fcc', borderRadius: '8px', color: '#c53030', fontSize: '14px' }}>
                        {erro}
                    </div>
                )}
            </div>
        </div>
    )
}
